import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { type Dispatch, type SetStateAction, useState } from 'react'

import { dmsState } from '@/app/store'
import { type ISpecialCondition } from '@/app/types/dmsTypes'
import { onRenderMarkdown } from '@/app/utils'
import { BlurApp } from '@/shared'

import { DatesRangesSpecialConditionModal } from './DatesRangesSpecialConditionModal/DatesRangesSpecialConditionModal'
import style from './Item.module.scss'

interface IProps extends ISpecialCondition {
    name: string
    insuranceProgramId: string
    polisId: string
    showProgramDescription: boolean
    setSconditionsList: Dispatch<SetStateAction<ISpecialCondition[]>>
}

export const Item = observer((props: IProps) => {
    const {
        id,
        name,
        polisId,
        insuranceProgramId,
        dateRanges,
        descriptions,
        showProgramDescription,
        setSconditionsList
    } = props
    const [showDescription, setShowDescription] = useState<boolean>(false)
    const [showRanges, setShowRanges] = useState<boolean>(false)

    const onShowMoreDetails = () => setShowDescription((prev) => !prev)
    const onDatesRangesClickHandler = () => {
        setShowRanges(true)
    }

    if (!id) {
        return null
    }

    const detailsBtn = showDescription ? 'Назад' : 'Описание'
    const datesBtn = dateRanges.length > 0 ? 'См. даты расширений' : 'Прикрепить'

    return (
        <div className={classNames(style.container, showDescription && style.containerBlured)}>
            {showRanges && (
                <DatesRangesSpecialConditionModal
                    ranges={dateRanges}
                    onClose={() => {
                        setShowRanges(false)
                        dmsState.onGetChosenInsured(polisId)
                    }}
                    programId={insuranceProgramId}
                    polisId={polisId}
                    specialConditionId={id}
                    setSconditionsList={setSconditionsList}
                />
            )}
            <div className={style.mainData}>
                <BlurApp show={showDescription} withScroll />
                <div className={style.itemName}>
                    <span>{name}</span>
                </div>
                {!showDescription && !showProgramDescription && (
                    <div className={style.specialConditionsBtn} onClick={onDatesRangesClickHandler}>
                        <span>{datesBtn}</span>
                    </div>
                )}
                <button className={classNames(style.btn, style.descriptionBtn)} onClick={onShowMoreDetails}>
                    {detailsBtn}
                </button>
            </div>
            {showDescription && (
                <div
                    className={style.descriptionWrapper}
                    dangerouslySetInnerHTML={{ __html: onRenderMarkdown(descriptions) }}
                />
            )}
        </div>
    )
})
